/* eslint-disable no-nested-ternary */
import { LayoutTitleContainer } from '@flatsy/core'
import Instruction from '@flatsy/core/Content/Instruction'
import FormatPrice from '@flatsy/core/Format/Price'
import { LayoutCards } from '@flatsy/core/Layout/Cards'
import Separator from '@flatsy/core/Layout/Separator'
import HotelOutlinedIcon from '@material-ui/icons/HotelOutlined'
import {
  bedroomsFormat,
  floorFormat,
  roomsFormat,
  surfaceFormat,
} from '@flatsy/utils/Functions/format/Conversions'
import SquareFootIcon from '@material-ui/icons/SquareFoot'
import LayersOutlinedIcon from '@material-ui/icons/LayersOutlined'
import DashboardOutlinedIcon from '@material-ui/icons/DashboardOutlined'
import PlaceOutlinedIcon from '@material-ui/icons/PlaceOutlined'
import Line from '@flatsy/core/Layout/Line'
import { Header1, SubBody1, Body3, Body2 } from '@flatsy/core/MaterialUi/Typo'
import theme from '@flatsy/core/MuiTheme/theme'
import EventIcon from '@material-ui/icons/Event'
import { priceValue } from '@flatsy/utils/Functions/format/Conversions'
import { Link } from '@material-ui/core'
import React from 'react'
import { LogoAgency } from 'src/utils/LogoAgency'
import clsx from 'clsx'
import i18n from '@flatsy/utils/translations'
import { DateTime } from '@flatsy/utils/dates'
import Carousel from '../Carousel'
import LoadingsSideBar from './Loading'
import useStyles from './Style'
import { componentProps } from './Type'

const QualificationSideBar: React.FC<componentProps> = ({
  asset,
  application,
  booking,
  useInstruction,
}) => {
  const classes = useStyles()

  const renderBedrooms = () => {
    if (asset?.bedrooms || asset?.bedrooms === 0) {
      return (
        <div className={classes.row}>
          <HotelOutlinedIcon className={classes.icon} />
          <SubBody1 className={classes.iconLabel}>{bedroomsFormat(asset.bedrooms)}</SubBody1>
        </div>
      )
    }
  }

  if (asset) {
    return (
      <div className={classes.secondaryWrapper}>
        <div className={classes.logoWrapper}>{LogoAgency(classes, asset?.logo_url)}</div>
        {useInstruction && booking && (
          <>
            <Instruction asset={asset} />
            <Separator size="16px" />
          </>
        )}
        <Carousel asset={asset} size="small" />
        <LayoutCards className={classes.secondaryCards}>
          <div>
            <div className={classes.textRow}>
              <div className={classes.flexColumn}>
                <Header1 lowerCase>
                  {<FormatPrice price={priceValue(asset)} />}{' '}
                  {!asset.is_sale && i18n.t('per_month').toLowerCase()}
                </Header1>
                {!asset.is_sale && (
                  <SubBody1 fontColor={theme.palette.secondary.dark}>
                    {i18n.t('utilities_included').toLowerCase()}
                  </SubBody1>
                )}
              </div>
              {asset.ad_url && (
                <Link href={asset.ad_url} target="_blank">
                  <Body2 fontColor={theme.palette.primary.main}>
                    {i18n.t('view_classified').toLowerCase()}
                  </Body2>
                </Link>
              )}
            </div>
            <Line marginTopBottom="16px" />
            {booking ? (
              <LayoutTitleContainer className={classes.dateInfo}>
                <EventIcon className={classes.icon} />
                <Body3 lowerCase className={classes.body3}>
                  {i18n.t('@date_at', {
                    value: DateTime.fromISO(`${booking.start_date}T${booking.start_time}`),
                  })}
                </Body3>
              </LayoutTitleContainer>
            ) : application && application.booking_wanted_date ? (
              <LayoutTitleContainer className={classes.dateInfo} line>
                <EventIcon className={classes.icon} />
                <Body3 lowerCase className={classes.body3}>
                  {i18n.t('@date_at', {
                    value: DateTime.fromISO(
                      `${application.booking_wanted_date}T${application.booking_wanted_time}`
                    ),
                  })}
                </Body3>
              </LayoutTitleContainer>
            ) : undefined}
            <div className={clsx(classes.section, classes.fourColumnGrid)}>
              <div className={classes.row}>
                <SquareFootIcon className={classes.icon} />
                <SubBody1 className={classes.iconLabel}>{surfaceFormat(asset.surface)}</SubBody1>
              </div>
              <div className={classes.row}>
                <LayersOutlinedIcon className={classes.icon} />
                <SubBody1 className={classes.iconLabel}>{floorFormat(asset.floor, true)}</SubBody1>
              </div>
              <div className={classes.row}>
                <DashboardOutlinedIcon className={classes.icon} />
                <SubBody1 className={classes.iconLabel}>
                  {roomsFormat(asset.number_of_rooms)}
                </SubBody1>
              </div>
              {renderBedrooms()}
            </div>
            <Line marginTopBottom="16px" />
            <div className={classes.flex}>
              <PlaceOutlinedIcon className={classes.icon} />
              <SubBody1 className={classes.description}>{asset.address_description}</SubBody1>
            </div>
          </div>
        </LayoutCards>
      </div>
    )
  }

  return (
    <div className={classes.loadingWrapper}>
      <LayoutCards>
        <LoadingsSideBar />
      </LayoutCards>
    </div>
  )
}

export default QualificationSideBar
